import { FormAddSidebarPanelEvent } from './FormAddSidebarPanelEvent';

/**
 * An event that is fired when Content Object form is rendered.
 * Returning anything will embed that result in rendering secondary column side by side to form.
 * If result is returned, the left navigation and right sidebar will be hidden.
 *
 * @memberof FlotiqPlugins.Events
 * @event "flotiq.form.secondary-column::add"
 * @type {FormAddSecondaryColumnEvent}
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to render secondary column.
 */

/**
 * @class
 * @extends FormAddSidebarPanelEvent
 * @memberof FlotiqPlugins.Events
 * @name FormAddSecondaryColumnEvent
 *
 */
export class FormAddSecondaryColumnEvent extends FormAddSidebarPanelEvent {}
